import type { RouteStop } from "../../../../../types/routeBuilder";
import { toLatLngLiteral } from "../../../../../utils/geo";
import { UNASSIGNED_ROUTE_ID } from "./sessionOps";

export type UnassignedMapStop = {
  routeId: typeof UNASSIGNED_ROUTE_ID;
  propertyVisitId: string;
  propertyId: string;
  index: number;
  color: null;
};

/** Map triangles use the same filtered visit order as the cards. */
export function unassignedMapStops({
  show,
  visits,
  locationFor,
}: {
  show: boolean;
  visits: ReadonlyArray<Pick<RouteStop, "propertyVisitId" | "propertyId">>;
  locationFor: (propertyId: string) => unknown;
}): UnassignedMapStop[] {
  if (!show) return [];
  return visits
    .map(
      (visit, index): UnassignedMapStop => ({
        ...visit,
        routeId: UNASSIGNED_ROUTE_ID,
        index,
        color: null,
      }),
    )
    .filter((stop) => toLatLngLiteral(locationFor(stop.propertyId)) != null);
}
